<template>
  <div>
    <div class="left">
      <h1>{{$t('success.congratulations')}}</h1>

      <p>
        {{$t('success.found', {points})}}
        <span v-if="points === 1">{{$t('success.keepItUp')}}</span>
      </p>

      <div class="label label--for-checkbox">
        <label>
          <input type="checkbox" v-model="expertMode">
          {{$t('config.expertMode')}}
          <br />
          <small>{{$t('config.expertModeDescription')}}</small>
        </label>
      </div>

      <div class="label label--for-select">
        <label>
          {{$t('config.findA')}}
          <select v-model="animal">
            <option :value="animal.key" v-for="animal in unlockedAnimals">
              {{$t(`animal.${animal.key}`)}}
            </option>
          </select>
        </label>
      </div>

      <small
        class="tip"
        v-if="points < ANIMALS[1].pointsRequired"
        v-html="$t('success.unlockAtFive')"
      />
      <small
        class="tip"
        v-if="points >= ANIMALS[1].pointsRequired && points < ANIMALS[2].pointsRequired"
        v-html="$t('success.unlockAtFifty')"
      />
      <small
        class="tip"
        v-if="points >= ANIMALS[2].pointsRequired"
        v-html="$t('success.unlockedAll')"
      />

      <find-button class="button" @click="setPage(PAGE_GAME)">
        {{$t('cta.findA', {animal: $t(`animal.${animal}`)})}}
      </find-button>
      <div class="social">
        <find-social-button network="facebook" />
        <find-social-button network="twitter" />
      </div>
    </div>
    <div class="right">
      <ins
        class="adsbygoogle"
        style="width:300px;height:250px"
        data-ad-client="ca-pub-7708254463438007"
        data-ad-slot="2580619829"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import {
  ANIMALS,
  PAGE_GAME,
} from 'constants';
import Button from 'components/Button.vue';
import SocialButton from 'components/SocialButton.vue';

export default {
  components: {
    'find-button': Button,
    'find-social-button': SocialButton,
  },
  data: () => ({
    ANIMALS,
    PAGE_GAME,
  }),
  computed: {
    unlockedAnimals() {
      return ANIMALS.filter(a => !a.pointsRequired || this.points >= a.pointsRequired);
    },
    animal: {
      get() {
        return this.$store.state.animal;
      },
      set(value) {
        this.$store.commit('setAnimal', value);
      },
    },
    expertMode: {
      get() {
        return this.$store.state.expertMode;
      },
      set(value) {
        this.$store.commit('setExpertMode', value);
      },
    },
    ...mapState({
      points: state => state.points,
    }),
  },
  methods: mapActions([
    'setPage',
  ]),
};
</script>

<style lang="scss" scoped>
h1 {
  margin-top: 0;
}

.right {
  display: none;
}

@media screen and (min-width: 800px) {
  .left {
    float: left;
    width: calc(100% - 300px - 1rem);
  }
  .right {
    display: block;
    float: right;
    margin-left: 1rem;
    width: calc(300px);
  }
}

.adsbygoogle {
  display: inline-block;
}

.label {
  &--for-checkbox {
    margin-bottom: 10px;
  }

  &::after {
    clear: both;
    content: '';
    display: table;
  }

  input[type=checkbox],
  label {
      cursor: pointer;
  }

  input[type=checkbox] {
    float: left;
    margin: 3px 10px 15px 0;
  }

  select {
    cursor: pointer;
    font: inherit;
    margin-left: 0.25em;
  }
}

.tip {
  display: block;
  margin-top: 1em;
}

.button {
  margin: 1rem 1rem 1rem 0;
}

.social {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// Congratulations.vue?3970f058